import React from 'react';
import moment from 'moment';

export const AccessCodePSCLogEntry = (props) => (
    <div className="status-table-row">
        <div className="status-table-cell">
            <label className="pe-textLabelInput__label">Access code sent to PDH:</label>
        </div>
        <div className="status-table-cell">
            <label className="pe-textLabelInput__label">{props.log.status} {moment(props.log.responseTime).format("MMM Do YYYY hh:mm Z")}</label>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/AccessCodeSetupComponents/AccessCodePSCLogEntry.js